import React from 'react'
import { BasicInfoWrapperProps } from '../BasicInfo'
import PriceMaximizer from '../../../../../common/display/priceMaximizer/PriceMaximizer'
import { useIsRecommendedPriceEnabled } from '../../../UseIsRecommendedPriceEnabled'
import { RecommendedPriceNotification } from '../recommended-price-notification/RecommendedPriceNotification'

export const priceMaximizer = () => (props: BasicInfoWrapperProps) => (
  <PriceMaximizer insertionData={props.insertionData} />
)

function RecommendedPriceSection({ insertionData }: Pick<BasicInfoWrapperProps, 'insertionData'>) {
  const isRecommendedPriceEnabled = useIsRecommendedPriceEnabled()

  return isRecommendedPriceEnabled ? <RecommendedPriceNotification /> : <PriceMaximizer insertionData={insertionData} />
}

export const recommendedPriceNotification = () => (props: BasicInfoWrapperProps) => (
  <RecommendedPriceSection insertionData={props.insertionData} />
)
